import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  ArcElement,   // Pie/Doughnut
  BarElement,   // Barras
  LineElement,  // Linhas (se usar)
  PointElement, // Pontos (se usar)
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  Filler
);